<template>
    <div>

    </div>
</template>

<script>
    import {EventBus} from "../../../assets/static/global/event-bus";
    export default {
        name: "coassRoomManagementSon",
        data(){
            return{
                zhi:'ss'
            }
        },
        mounted(){
            EventBus.$on('shareContent',()=>{
                console.log('触发了子项');

            })
        },
        beforeDestroy(){
          EventBus.$off('shareContent');
        },
        methods:{

        }
    }
</script>

<style scoped>

</style>
